export default __webpack_public_path__ + "static/media/tuu.70351e03.jpg";